import { Container } from './styles'

import { useCart } from '../../hooks/useCart'
import { ReactComponent as CartIcon } from '../../assets/shopping-cart.svg'
import { HeadPerfilLogo } from '../HeadPerfilLogo'

export const OrderHeader = () => {
  const { cart } = useCart()
  const quantityCart = cart.reduce((acc, item) => acc + item.quantity, 0)
  return (
    <Container>
      <HeadPerfilLogo />
      <div>
        <div>
          <h3>Meus Pedidos</h3>
          <span>{<strong>{`${quantityCart}`.padStart(2, '0')} items</strong>}</span>
        </div>
        <CartIcon />
      </div>
    </Container>
  )
}
